(() => {
  if (window.gimmeProductPanel) return;
  window.gimmeProductPanel = true;
  const storageKey = 'gimme-favourites';

  const readFavourites = () => {
    try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (error) { return []; }
  };

  const writeFavourites = favourites => {
    try { localStorage.setItem(storageKey, JSON.stringify(favourites)); } catch (error) { /* Storage may be unavailable. */ }
  };

  const syncWishlist = (root = document) => {
    const favourites = readFavourites();
    root.querySelectorAll('[data-gimme-wishlist]').forEach(button => {
      button.setAttribute('aria-pressed', String(favourites.includes(button.dataset.productId)));
    });
  };

  document.addEventListener('click', event => {
    const wishlist = event.target.closest('[data-gimme-wishlist]');
    if (wishlist) {
      const favourites = readFavourites();
      const productId = wishlist.dataset.productId;
      const updated = favourites.includes(productId) ? favourites.filter(id => id !== productId) : [...favourites, productId];
      writeFavourites(updated);
      wishlist.setAttribute('aria-pressed', String(updated.includes(productId)));
      return;
    }

    const bulkButton = event.target.closest('[data-gimme-bulk-buy]');
    if (bulkButton) {
      const productInfo = bulkButton.closest('product-info');
      const quantity = productInfo?.querySelector('.quantity__input');
      const submit = productInfo?.querySelector('.product-form__submit');
      if (!quantity || !submit) return;
      quantity.value = bulkButton.dataset.gimmeBulkBuy;
      quantity.dispatchEvent(new Event('input', { bubbles: true }));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
      submit.click();
    }
  });

  const tidyPolicyLists = (root = document) => {
    root.querySelectorAll('.gimme-product-policies .rte').forEach(policy => {
      policy.querySelectorAll('li, p').forEach(element => {
        if (!element.textContent.replace(/\u00a0/g, ' ').trim() && !element.querySelector('img, video, iframe, table')) element.remove();
      });
      policy.querySelectorAll('li').forEach(item => {
        while (item.firstElementChild?.tagName === 'BR') item.firstElementChild.remove();
        while (item.lastElementChild?.tagName === 'BR') item.lastElementChild.remove();
      });
    });
  };
  tidyPolicyLists();
  document.addEventListener('shopify:section:load', event => tidyPolicyLists(event.target));
  syncWishlist();
  document.addEventListener('product-info:loaded', event => syncWishlist(event.target));
  document.addEventListener('shopify:section:load', event => syncWishlist(event.target));
})();
